import React from 'react';

const ONLINE_WINDOW_MS = 15 * 60 * 1000;

export function isOnlineFromLastSeenAt(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return false;
  const diff = Date.now() - t;
  return diff >= 0 && diff < ONLINE_WINDOW_MS;
}

/** Точка справа снизу на аватаре: зелёная «на бирже», серая иначе (как в профиле, 15 мин). */
export function PresenceStatusDot({ lastSeenAt }: { lastSeenAt?: string | null }) {
  const online = isOnlineFromLastSeenAt(lastSeenAt);
  return (
    <span
      className={`fc-presence-dot${online ? ' fc-presence-dot--online' : ''}`}
      aria-hidden
      title={online ? 'На бирже' : 'Не в сети'}
    />
  );
}
